export default "__VITE_ASSET__JbcchlAw__"